import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { Actions } from '../../actions';
import { CloseMenu } from '@webapp/store/ui/action-creators';
import { ImportCatalogSuccess } from '../action-creators';
import { IMPORT_CATALOG_SUCCESS } from '../actions';
import { GetCatalog } from '@webapp/store/catalog/action-creators';

export const catalogImportedEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Action, ImportCatalogSuccess>(IMPORT_CATALOG_SUCCESS),
    concatMap((action) => {
      return [
        new CloseMenu(undefined, true),
        new GetCatalog({ type: 'COLLABORATOR', artistId: action.artistId }),
      ];
    })
  );
